import React, { createContext, useContext, useMemo } from "react";

type ContextState = {
  customer: Customer;
};

type Customer = {
  key: string;
  name: string;
  url: string;
};

const SettingsContext = createContext<ContextState | undefined>(undefined);

export function SettingsProvider({ customer, children }: { customer: Customer; children: React.ReactNode }) {
  const memoizedValue = useMemo(() => {
    return {
      customer,
    };
  }, [customer]);

  return <SettingsContext.Provider value={memoizedValue}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error("useSettings must be used within an SettingsProvider");
  }

  return context;
}
